<script setup lang="ts">
import type { Component } from 'vue';

defineProps<{ logoComponent: Component; text: string }>();
</script>
<template>
  <div class="loading-overlay">
    <div class="loading-overlay-content">
      <component :is="$props.logoComponent" style="padding: 0" />
      <div class="loading-overlay-text" v-text="$props.text" />
    </div>
  </div>
</template>
<style scoped>
.loading-overlay {
  background-color: color-mix(
    in srgb,
    var(--nxt-brand-subtle-bg) 90%,
    transparent
  ); /* NORMALIZE: was a semi-transparent primary tint */
  backdrop-filter: blur(0.5em); /** 8px */
  container-type: inline-size;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: var(--nxt-z-modal);

  .loading-overlay-content {
    font-size: var(--nxt-font-size-xs); /** xs */
    font-family: var(--nxt-font);
    font-weight: var(--nxt-font-weight-semibold);
    color: var(--nxt-brand-bg);

    position: absolute;
    top: 50%;
    left: 50%;
    width: 12em; /** 144px */
    transform: translate(-50%, -50%);
    padding: var(--nxt-space-md); /** 12px */
    border-radius: var(--nxt-radius-md); /** 6px */

    display: flex;
    flex-direction: column;
    gap: var(--nxt-space-xs); /** 6px */

    .loading-overlay-text {
      background-color: var(--nxt-brand-subtle-bg);
      text-align: center;
      padding: calc(0.25em / 0.75); /** 4px */
      border-radius: var(--nxt-radius-md); /** 6px */
    }
  }
}
</style>
